/* eslint-disable */
// src/utils/tableSchemas.js

/*
 * Define columnas por tipo y modo (edit/read), anchos y etiquetas adaptativas.
 * Opción compact para móviles y hideTotal para bloques que no la necesitan.
 * Fuente única de verdad de headers (“Entrada/Salida”, “Ingreso” en Rockola, etc.).
 */

export function getColumns(type, { mode = "edit", hideTotal = false, compact = false } = {}) {
  const isEdit = mode === "edit";
  // === Anchos revisados para que SUMEN 100% y se alineen entre tablas ===
  // Más espacio a "Nota", menos a "Máquina" y al botón "✔"
  // Más espacio para Nota y ✔, recortando Máquina/Entrada/Salida/Total.
  const baseW = compact
    ? {
        machine: "16%",
        in: "22%",
        out: "18%",
        total: "12%",
        note: "23%",
        confirm: "9%",
      }
    : {
        machine: "19%",
        in: "23%",
        out: "19%",
        total: "13%",
        note: "18%",
        confirm: "8%",
      };

  // etiquetas por modo/tipo
  const inHeader = type === "Rockola" && !isEdit ? "Ingreso" : isEdit ? "Ingresos" : "Entrada";
  const outHeader = isEdit ? "Salidas" : "Salida";

  const withMaybeTotal = (cols) => (hideTotal ? cols.filter((c) => c.accessor !== "Total") : cols);

  const lock = (w) => ({ width: w, minWidth: w, maxWidth: w });
  const common = {
    Machine: { Header: "Máquina", accessor: "Machine", align: "center", ...lock(baseW.machine) },
    In: { Header: inHeader, accessor: "In", align: "center", ...lock(baseW.in) },
    Out: { Header: outHeader, accessor: "Out", align: "center", ...lock(baseW.out) },
    Total: { Header: "Total", accessor: "Total", align: "center", ...lock(baseW.total) },
    Note: { Header: "Nota", accessor: "Note", align: "center", ...lock(baseW.note) },
  };

  // === Espaciadores: mismas anchuras pero encabezado vacío ===
  const OutSpacer = { ...common.Out, Header: "" };
  const TotalSpacer = { ...common.Total, Header: "" };

  const withNote = (cols) => {
    if (isEdit) return [...cols, common.Note];
    return cols;
  };

  switch (type) {
    case "Rockola": {
      // Rockola no usa Salida ni Total, pero agregamos espaciadores para alinear
      const cols = withNote([common.Machine, common.In, OutSpacer, TotalSpacer]);
      return withMaybeTotal(cols);
    }
    case "Pool":
    case "Tejo": {
      // Pool/Tejo no usan Salida; dejamos un espaciador para alinear
      const cols = withNote([common.Machine, common.In, OutSpacer, common.Total]);
      return withMaybeTotal(cols);
    }
    case "Peluchera": {
      const cols = withNote([common.Machine, common.In, common.Out, common.Total]);
      return withMaybeTotal(cols);
    }
    case "Tragamoneda":
    default: {
      const tragaNote = { ...common.Note, ...lock(baseW.total) };
      const cols = isEdit
        ? [common.Machine, common.In, common.Out, common.Total, tragaNote]
        : [common.Machine, common.In, common.Out, common.Total];
      return withMaybeTotal(cols);
    }
  }
}
